<template>
  <div class="p-0">
    <app-content class="load-simulation">
      <load-simulation-header :simulationData="simulationData"/>
      <load-simulation-chart
        :simulationTotalLossLife="simulationData.simulationTotalLossLife"
        :remainingLifeAfterSimulation="simulationData.remainingLifeAfterSimulation"/>
      <b-row
        class="mt-4 no-internal-print"
        align-h="end">
        <b-col md="3" class="mb-xs-2 mb-sm-2">
          <excel-export-button
            class="load-simulation__export"
            @click="$event.wait(exportExcel())"
          />
        </b-col>
        <b-col md="3">
          <b-button
            block
            variant="primary"
            @click="closeTab"
          >
            {{ $t('actions.close') }}
          </b-button>
        </b-col>
      </b-row>
    </app-content>
  </div>
</template>

<script>
import AppContent from '@/components/globals/appContent/AppContent';
import ExcelExportButton from '@/components/buttons/ExcelExportButton';
import eventBus from '@/services/globalEventBus';
import events from '@/domain/events/engineering';
import LoadSimulationHeader from '@/domain/components/installation/engineering/loadSimulation/reports/Header';
import LoadSimulationChart from '@/domain/components/installation/engineering/loadSimulation/reports/Chart';
import loadSimulationService from '@/domain/services/installation/engineering/loadSimulation/loadSimulationService';

export default {
  name: 'index',
  components: {
    AppContent,
    ExcelExportButton,
    LoadSimulationHeader,
    LoadSimulationChart,
  },
  data: () => ({
    simulationData: {},
    chartData: [],
  }),
  created() {
    const { assetModuleId, resultId } = this.$route.params;
    loadSimulationService.getResultHeader(assetModuleId, resultId)
      .then((data) => {
        this.simulationData = data;
        eventBus.emit(events.onSimulationHeaderSuccess);
        this.$pushAlert({ code: 'MS015' });
      });
  },
  methods: {
    closeTab() {
      this.$confirmMessage({ code: 'MC035' })
        .accepted(() => window.close());
    },
    exportExcel() {
      const { assetModuleId, resultId } = this.$route.params;
      return loadSimulationService.downloadResult(assetModuleId, resultId)
      .then(() => {
        this.$pushAlert({ code: 'MS011' });
      });
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"

.load-simulation
  &__export
    width: 100%
    height: 100%
    justify-content: center !important
    ::v-deep
      & .excel-export-button__icon
        margin-right: 1em !important
</style>
